import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { postFunctionData } from '@/utils/supabaseFunctions';

interface StripeBalance {
  available: number;
  pending: number;
  currency: string;
  isTestMode: boolean;
}

export const useStripeBalance = () => {
  const { user } = useAuth();
  const organizationId = user?.user_metadata?.organization_id;

  return useQuery({
    queryKey: ['stripeBalance', organizationId],
    queryFn: async (): Promise<StripeBalance> => {
      try {
        // Use our new utility for better error handling and authentication
        const data = await postFunctionData<StripeBalance>(
          'get-stripe-balance', 
          { organizationId }
        );
        
        return data;
      } catch (error) {
        console.error('Error fetching Stripe balance:', error);
        throw error;
      }
    },
    enabled: !!organizationId,
    // Add cache settings to reduce API calls
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false
  });
};
